module.exports = __webpack_public_path__ + "assets/pdf/BN05-cn-heatwave-cities.67c06756.pdf";